import { useCallback } from 'react';

import dayjs from 'dayjs';

import { DATE_SIMPLE } from '@cast/constants';
import { BestPracticeCheckStandard } from '@cast/types';
import { downloadFile } from '@cast/utils';

import { useOrganizations } from '@cast/shared-organization-context-data-access';

import { useGetBestPracticeChecks } from './useGetBestPracticeChecks';
import { prepareComplianceExportData } from '../../utils';

type UseReportDownloadProps = {
  standard: BestPracticeCheckStandard;
  clusterIds?: string[];
};

export const useReportDownload = ({
  standard,
  clusterIds,
}: UseReportDownloadProps) => {
  const { currentOrganization } = useOrganizations();

  const { checks, isLoading, error } = useGetBestPracticeChecks({
    filters: { standard },
    clusterIds,
  });

  const download = useCallback(async () => {
    downloadFile(
      prepareComplianceExportData(checks),
      `compliance-${currentOrganization?.name}-${dayjs().format(
        DATE_SIMPLE
      )}.csv`
    );
  }, [checks, currentOrganization?.name]);

  return { download, isLoading, hasError: !!error };
};
